<!--
    描述：列过滤公用弹窗
    时间：2021-09-17
    Created by 王帅
-->
<template>
	<el-dialog :visible.sync="dialogObj.visible"
			   :title="dialogObj.title"
			   :width="dialogObj.width"
			   append-to-body
			   center
			   @closed="handleClosed">
		<div class="filter-column-layout">
			<el-card v-for="(item, index) in filterArray"
					 :key="'card' + index"
					 :shadow="shadow"
					 class="column-card">
				<div class="column-row">
					<!-- 左侧标题 + 全选 -->
					<div :style="activeLeftStyle">
						{{ item.title }}
						<el-checkbox v-if="showCheckAll"
									 v-model="item.checkAll"
									 class="ml10"
									 @change="handleCheckAll($event, index)">全选</el-checkbox>
					</div>
					<!-- 右侧列名 -->
					<div class="right-check">
						<el-row>
							<el-col :span="6"
									class="mb3"
									v-for="(m, n) in item.columns"
									:key="'column' + index + n">
								<el-checkbox v-model="m.visible"
											 v-if="!m.noFilter">{{ m.title }}</el-checkbox>
							</el-col>
						</el-row>

					</div>
				</div>
			</el-card>
		</div>

		<!-- 底部按钮 -->
		<div slot="footer">
			<el-button size="small"
					   @click="dialogObj.visible = false">取消</el-button>
			<el-button size="small"
					   type="primary"
					   :loading="btnLoading"
					   @click="doSubmit">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import * as HomeApi from '@/api/home/homeIndex'
import { mapState } from 'vuex'
export default {
	name: '',
	props: {
		// 列过滤对象数组
		filterColumns: {
			type: Array,
			default: () => {
				return []
			},
		},

		// 是否展示全选
		showCheckAll: {
			type: Boolean,
			default: true,
		},

		// 是否列过滤记忆
		memory: {
			type: Boolean,
			default: false,
		},

		// 列过滤记忆模块
		busType: {
			type: String,
			default: '', // always / hover / never
		},

		// 阴影时机
		shadow: {
			type: String,
			default: 'hover', // always / hover / never
		},

		// 左侧宽度
		leftWidth: {
			type: String,
			default: '130px',
		},

		// 弹窗宽度
		customDialog: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			oldArray: [], // 原数组
			filterArray: [],
			dialogObj: {
				visible: false,
				title: '列过滤',
				width: '1000px',
			},
			btnLoading: false,
		}
	},
	created() {
		this.oldArray = JSON.parse(JSON.stringify(this.filterColumns))
		this.filterArray = this.filterColumns
		if (this.customDialog.visible) {
			this.dialogObj = this.customDialog
		}
	},
	methods: {
		// 点击全选
		handleCheckAll(val, index) {
			if (
				this.filterArray[index] &&
				this.filterArray[index].columns.length > 0
			) {
				this.filterArray[index].columns.map((x) => {
					// 不参与过滤的不变化
					if (!x.noFilter) {
						x.visible = val
					}
				})
			}
		},

		// 点击确定
		doSubmit() {
			this.btnLoading = true
			if (!this.memory) {
				this.$emit('onFilter', this.filterArray)
				this.dialogObj.visible = false
				this.btnLoading = false
				return
			}
			this.saveSelfData()
		},

		// 保存列过滤数据
		saveSelfData() {
			let fileds = this.filterColumns[0].columns
			let dealColumn = []
			//组装后台需要的数据格式
			fileds.forEach((f, index) => {
				dealColumn.push({
					name: f.title,
					field: f.property,
					isChecked: f.visible,
					index,
				})
			})
			HomeApi.saveSelfColumns({
				createUserid: this.userInfo.id,
				busType: this.busType,
				columnVisible: dealColumn,
			}).then((res) => {
				this.$emit('onFilter', this.filterArray)
				this.btnLoading = false
				this.dialogObj.visible = false
			})
		},

		// 关闭弹窗
		handleClosed() {
			// this.filterArray = JSON.parse(JSON.stringify(this.oldArray))
		},
	},
	computed: {
		// 左侧样式
		activeLeftStyle() {
			return {
				width: this.leftWidth,
				flexShrink: 0,
				borderRight: '1px solid #ddd',
				marginRight: '20px',
				paddingRight: '20px',
				textAlign: 'right',
			}
		},

		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
	watch: {
		// 监听单选、复选变化
		filterArray: {
			handler: function (arr) {
				arr.map((item, index) => {
					let _false = item.columns.find((x) => x.visible === false)
					item.checkAll = !_false
				})
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="less">
.filter-column-layout {
	overflow-y: auto;

	.column-card {
		margin: 5px 5px 20px;
		background-color: #fbfbfb;
	}

	.column-row {
		display: flex;
	}

	.right-check {
		width: 100%;
		line-height: 24px;
	}

	.mb3 {
		margin-bottom: 3px;
	}
}
</style>
